import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import { Element } from "react-scroll";
import { useEffect, useRef } from "react";

import Schendule from "./Schendule";
import Speakers from "./Speakers";
import AcercaDe from "./Aboutus";

import "../../assets/css/style.css";

import banner from "../../assets/images/2025/casaduana_bannerHome.jpg";
import banner_movil from "../../assets/images/2025/casaduana_bannerHome_movil.jpg";
import banner_logo from "../../assets/images/2025/casaduana_LogoPrincipal.png";

import btn_registro from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_Registrate.svg";

import fecha from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_calendario.svg";
import lugar from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_gps.svg";

import img_cuadro_1 from "../../assets/images/2025/casaduana_gratis.png";
import img_cuadro_2 from "../../assets/images/2025/casaduana_networking.png";
import img_cuadro_3 from "../../assets/images/2025/casaduana_tecnologia.png";

import "../../assets/css/conferencia.css";
import Sponsors from "./Sponsors";
import FromRegister from "../registro/FromRegister";


const Home = (props) => {
  const { idioma } = props;
  const itemsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-beneficio");
          }
        });
      },
      { threshold: 0.3 }
    );

    itemsRef.current.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
const bloquesRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-acerca");
          }
        });
      },
      { threshold: 0.25 }
    );

    bloquesRef.current.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return (
    <>
      <Row>
        <Col span={24}>
          <Row style={{ position: "relative" }}>
            {/* Imagen de fondo */}
            <Col xs={0} md={24}>
              <img
                src={banner}
                style={{ width: "100%", display: "block" }}
                alt="banner"
              />
            </Col>
             <Col xs={24} md={0}>
              <img
                src={banner_movil}
                style={{ width: "100%", display: "block" }}
                alt="banner"
              />
            </Col>

            {/* Contenido superpuesto */}
            <Col
              span={24}
              className="banner-overlay"
              style={{
                position: "absolute",
                top: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "20px",
              }}
            >
              <Row style={{ width: "100%" }} justify="center">
                {/* Fecha */}
                <Col xs={22} md={20} className="fade-item">
                  <p
                    className="color_blanco fecha_banner_home"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <img src={fecha} style={{ width: 35 }} alt="" />
                    <span>23 de enero 2026 • 9:00 h</span>
                  </p>
                </Col>

                {/* Logo principal */}
                <Col xs={22} md={16} className="fade-item">
                  <img
                    src={banner_logo}
                    style={{ width: "100%", maxWidth: 800 }}
                    alt="banner logo"
                  />
                </Col>

                {/* Botón y lugar */}
                <Col
                  xs={22}
                  md={18}
                  className="fade-item"
                  style={{ marginTop: 20 }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 25,
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <Link to="#registro">
                      <img
                        src={btn_registro}
                        style={{ width: 180 }}
                        alt="button registro"
                      />
                    </Link>

                    <Link
                      to="#registro"
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <img src={lugar} style={{ width: 55 }} alt="lugar" />
                      <span className="color_blanco fecha_banner_home">
                        Hotel Marquis Reforma • CDMX
                      </span>
                    </Link>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Element name="#acerca-de"></Element>
     <AcercaDe />
      <Element name="#beneficios"></Element>
      <Row id="beneficios" justify="center" className="beneficios-wrapper">
        {[img_cuadro_1, img_cuadro_2, img_cuadro_3].map((img, idx) => (
          <Col
            key={idx}
            xs={20}
            sm={12}
            md={6}
            className="beneficio-item hidden-beneficio"
            ref={(el) => (itemsRef.current[idx] = el)}
            style={{ textAlign: "center" }}
          >
            <img src={img} className="beneficio-img" alt="" />
          </Col>
        ))}
      </Row>
      <Row
        className="contenedor_conferencias_"
        style={{ backgroundColor: "#f6fafc" }}
      >
        <Col id="programa" span={24} className="back_agenda__">
          <Element name="#programa"></Element>
          <Schendule idioma={idioma} />
        </Col>
        <Col id="registro" span={24}>
          <Element name="#registro"></Element>
          <FromRegister idioma={idioma} />
        </Col>
        <Col id="speakers" span={24}>
          <Element name="#speakers"></Element>
          <Speakers />
        </Col>
        <Col id="organizadores" span={24}>
          <Element name="#organizadores"></Element>
          <Sponsors />
        </Col>
      </Row>
    </>
  );
};

export default Home;
